import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        operationsIsShow: true,
        eKatFormIsShow: false,

        rowActions: [
            {
                btn_text: '<i class="fas fa-plus"></i>',
                title: 'Rögzítés Eseménykatalógusba',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showInsertEKat',
                additionalButtonVisible: "isShowInsertEkatOperation"
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Módosítás Eseménykatalógusban',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showEditEKat',
                additionalButtonVisible: "isShowEditEkatOperation"
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "patientId",
                label: "Páciens ID",
                visibility: false
            },
            {
                name: "attendance.eesztId",
                label: "EESZT ID",
                visibility: false
            },
            {
                name: "operationTypeId",
                label: "Műtét típus ID",
                visibility: false
            },
            {
                name: "operationType.operation",
                label: "Műtét típusa",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "startDate",
                label: "Műtét kezdete",
                visibility: false,
            },
            {
                name: "startTime",
                label: "Műtét kezdete",
                visibility: false,
            },
            {
                name: "endDate",
                label: "Műtét vége",
                visibility: false,
            },
            {
                name: "endTime",
                label: "Műtét vége",
                visibility: false,
            },
            {
                name: "startDateTime",
                label: "Műtét kezdete",
                visibility: true,
                slot_name: "operationStart_format"
            },
            {
                name: "endDateTime",
                label: "Műtét vége",
                visibility: true,
                slot_name: "operationEnd_format"
            },
            {
                name: "room.name",
                label: "Műtő szoba",
                visibility: true
            },
            {
                name: "doctor.name",
                label: "Operatőr",
                visibility: true
            },
            {
                name: "dresser.name",
                label: "Műtős",
                visibility: true
            },
            {
                name: "anesthetist.name",
                label: "Anesztéziát végzi",
                visibility: true
            },
            {
                name: "anesthesia.text",
                label: "Anesztézia",
                visibility: true
            },
            {
                name: "preopControl",
                label: "Preop. szükséges vizsgálatok",
                visibility: true
            },
            {
                name: "anesthesiaControl",
                label: "Anest. vizsgálat történt",
                visibility: true
            },
            {
                name: "arrivalDateOfThePatient",
                label: "Beteg érkezése",
                visibility: true,
                slot_name: "resultDate_format"
            },
            {
                name: "durationOfCare",
                label: "Befekvés várható időtartama",
                visibility: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],

        inpatientEKatFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        inpatientEKatFormHeaderFields: [
            {
                name: "esemenyTipus",
                label: "Esemény típus",
                formType: "select",
                formSize: 3,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getEsemenyTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatasKezdete",
                label: "Ellátás kezdete",
                formType: "dateTime",
                formSize: 2,
                formVisible: true
            },
            {
                name: "ellatasVege",
                label: "Ellátás vége",
                formType: "dateTime",
                formSize: 2,
                formVisible: true
            },
            {
                name: "ellatoOrvos",
                label: "Ellátó orvos",
                formSize: 2,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctorForEeszt,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatoOsztaly",
                label: "Ellátó osztály",
                formSize: 2,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyIdToEeszt,
                    formatText: function (val) {
                        return val.siteName;
                    },
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "fekvobetegFelvetelTipusa",
                label: "Fekvőbeteg felvétel típusa",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getFekvobetegFelvitelTipusaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "fekvobetegFelvetelJellege",
                label: "Fekvőbeteg felvétel jellege",
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getFekvobetegJellegeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "paciensTovabbiSorsa",
                label: "Páciens további sorsa",
                formSize: 3,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getPaciensTovabbiSorsaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ]
    }
}